import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TabHeadersModule } from '../../atoms/tab-headers/tab-headers.module';
import { TabModule } from '../../atoms/tab/tab.module';
import { TabsComponent } from './tabs.component';

@NgModule({
  declarations: [TabsComponent],
  exports: [TabsComponent],
  imports: [CommonModule, TabModule, TabHeadersModule]
})
export class TabsModule {}
